export default "/_next/static/images/dog1-011932e58e3e0834cf8ff721f9ddab35.png";